import { CurrencyInput } from '@components/core-ui/form-elements/CurrencyInput';
import { Select } from '@components/core-ui/form-elements/Select';
import { hasEditableRateAmount } from '../../helpers/hasEditableRateAmount';
import { parseBillingRateType } from '../../helpers/parseBillingRateType';
import { TProps } from './types/TProps';

const rateTypeOptions = [
  { label: 'Disallowed', value: 'DISALLOWED' },
  { label: 'Flat Fee', value: 'FLAT_FEE' },
  { label: 'Fixed per hour rate', value: 'PER_HOUR' },
  { label: 'Tier Rate', value: 'TIER_RATE' },
];

export const RateField = ({
  label,
  name,
  testId,
  rateType,
  rate,
  disabled = false,
  rateTypeLocked = false,
  onRateTypeChange,
  onRateChange,
  children,
}: TProps) => (
  <div className="input-wrapper">
    <div className="label">{label}</div>
    <Select
      name={name}
      label="Type"
      value={rateType}
      onChange={(_, value) => {
        const nextRateType = parseBillingRateType(value);
        if (nextRateType) {
          onRateTypeChange(nextRateType);
        }
      }}
      options={rateTypeOptions}
      required={false}
      disabled={disabled || rateTypeLocked}
      testId={testId}
    />
    {children}
    {hasEditableRateAmount(rateType) ? (
      <CurrencyInput
        name={`${name}Amount`}
        onChange={(_, value) => onRateChange(value)}
        label="$ 0"
        value={rate}
        disabled={disabled}
      />
    ) : null}
  </div>
);
